import { Component, OnInit, HostListener } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "../../interfaces/user";
import { environment } from "../../../environments/environment";
import { SessionService } from "../../services/session/session.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  user = {} as User;
  error: string;
  return = "" as string;
  env: any = environment;
  rememberMe: boolean = false;
  loading: boolean;
  activated: boolean;
  invalidtoken: boolean;
  passwordreset: boolean;
  sessionLoginRedirect: boolean;
  successText: string =
    "Dein Account ist freigeschaltet. Du kannst Dich nun einloggen.";
  invalidTokenText: string = "Token ungültig oder bereits verwendet.";
  passwordResetSuccessText: string =
    "Passwort gespeichert. Du kannst Dich jetzt mit Deinem neuen Passwort anmelden";
  userErrorMessager: string;
  registrationSend: string;

  constructor(
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.return = params["return"] || "/projects";
      this.user.email = params["email"] || null;
      this.activated = params["activated"] || null;
      this.invalidtoken = params["invalidtoken"] || null;
      this.passwordreset = params["pwreset"] || null;
      this.registrationSend = params["registerNotify"] || null;
    });
    setTimeout(() => {
      $("#email").focus();
      $("#email").select();
    }, 100);

    if (!sessionStorage.length) {
      // Ask other tabs for session storage
      localStorage.setItem("getSessionStorage", name);
    }
  }

  @HostListener("window:storage", ["$event"])
  async onStorageEvent(event) {
    if (
      event.key == "sessionStorage" &&
      !sessionStorage.length &&
      !this.sessionLoginRedirect
    ) {
      // sessionStorage is empty -> fill it

      this.sessionLoginRedirect = true;

      var data = JSON.parse(event.newValue);

      for (let key in data) {
        sessionStorage[key] = data[key];
      }

      if (sessionStorage["token"]) {
        this.sessionService.setRoles(
          JSON.parse(this.sessionService.getItem("roles"))
        );
        await this.router.navigateByUrl(this.return);
      } else this.sessionLoginRedirect = false;
    }
  }

  login() {
    this.loading = true;
    this.auth
      .login(this.user, this.rememberMe)
      .then((isFirstLogin) => {
        this.loading = false;
        const routeParams = isFirstLogin ? { firstLogin: isFirstLogin } : {};
        this.router.navigate([this.return, routeParams]);
      })
      .catch((error) => {
        if (error.status === 402) throw error;
        this.loading = false;
        if (error.error.internalStatus === 601) {
          this.router.navigate(["/resend-link"], {
            queryParams: {
              email: this.user.email,
              status: 0,
            },
          });
        } else {
          this.error = error.error.message;
          this.successText = null;
          this.passwordResetSuccessText = null;
          this.passwordreset = null;
          this.activated = null;
          this.userErrorMessager =
            "Die E-Mail-Adresse oder das Passwort ist ungültig.";
        }
      });
  }

  /**
   * toggle rememberMe variable
   */
  rememberMeToggle() {
    this.rememberMe = !this.rememberMe;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/login/login.component.ts